var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_c('span',[_vm._v(_vm._s(_vm.ip)+"/"+_vm._s(_vm.mask))])]),_vm._v(" "),_c('td',{staticClass:"action-column"},[_c('span',[_c('a',{staticClass:"icon-delete has-tooltip",attrs:{"title":_vm.t('bruteforcesettings', 'Delete')},on:{"click":function($event){return _vm.$emit('delete', _vm.id)}}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }